var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFt1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#DB0035",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3479 11.7553C14.2271 11.7553 14.9399 11.0425 14.9399 10.1633C14.9399 9.28405 14.2271 8.57129 13.3479 8.57129C12.4686 8.57129 11.7559 9.28405 11.7559 10.1633C11.7559 11.0425 12.4686 11.7553 13.3479 11.7553Z",
    fill: "#DB0035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.592 17.0614C18.4712 17.0614 19.184 16.3487 19.184 15.4694C19.184 14.5902 18.4712 13.8774 17.592 13.8774C16.7128 13.8774 16 14.5902 16 15.4694C16 16.3487 16.7128 17.0614 17.592 17.0614Z",
    fill: "#DB0035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4084 22.8984C15.2876 22.8984 16.0004 22.1856 16.0004 21.3064C16.0004 20.4271 15.2876 19.7144 14.4084 19.7144C13.5292 19.7144 12.8164 20.4271 12.8164 21.3064C12.8164 22.1856 13.5292 22.8984 14.4084 22.8984Z",
    fill: "#DB0035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3062H23.4286",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3066 19.1836L23.429 21.3061L21.3066 23.4285",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3479 11.7553C14.2271 11.7553 14.9399 11.0425 14.9399 10.1633C14.9399 9.28405 14.2271 8.57129 13.3479 8.57129C12.4686 8.57129 11.7559 9.28405 11.7559 10.1633C11.7559 11.0425 12.4686 11.7553 13.3479 11.7553Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.592 17.0614C18.4712 17.0614 19.184 16.3487 19.184 15.4694C19.184 14.5902 18.4712 13.8774 17.592 13.8774C16.7128 13.8774 16 14.5902 16 15.4694C16 16.3487 16.7128 17.0614 17.592 17.0614Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4084 22.8984C15.2876 22.8984 16.0004 22.1856 16.0004 21.3064C16.0004 20.4271 15.2876 19.7144 14.4084 19.7144C13.5292 19.7144 12.8164 20.4271 12.8164 21.3064C12.8164 22.1856 13.5292 22.8984 14.4084 22.8984Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0009 15.4697H11.4906C9.87887 15.4697 8.57227 16.7763 8.57227 18.3881C8.57227 19.9999 9.87887 21.3065 11.4906 21.3065H12.8172",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1844 15.4697H20.7762C22.2415 15.4697 23.4293 14.2819 23.4293 12.8166C23.4293 11.3514 22.2415 10.1636 20.7762 10.1636H14.9395",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7559 10.1636H8.57227",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt1);
export default __webpack_public_path__ + "static/media/ft_1.70fd0e0d7c730943bb93f15b09525788.svg";
export { ForwardRef as ReactComponent };